import { Box, Skeleton } from "@mui/material";

export function ProjectStorageSkeleton() {
  return (
    <Box display="flex" flex={1} minHeight={480} bgcolor="#F9FCFF">
      <Box
        width={300}
        flexShrink={0}
        px={3}
        py={3}
        borderRight="1px solid #E8E8E8"
      >
        <Skeleton variant="text" width="70%" height={32} sx={{ mb: 2 }} />
        {Array.from({ length: 10 }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            height={24}
            sx={{ mb: 1.5 }}
          />
        ))}
      </Box>
      <Box flex={1} px={3} py={3}>
        <Skeleton variant="text" width="30%" height={28} sx={{ mb: 2 }} />
        <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} variant="rounded" height={56} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
